import LoadingIcons from 'react-loading-icons';

const GlobalLoader = () => {
  return (
    <div
      style={{
        position: 'absolute',
        right: 10,
        bottom: 10,
        padding: 10,
        paddingBottom: 4,
        borderRadius: 4,
        backgroundColor: '#303030',
        zIndex: 100,
      }}
    >
      <LoadingIcons.Grid width={30} height={30} />
    </div>
  );
};

export default GlobalLoader;
